import { InjectionToken } from '@angular/core'
import { Converter } from '@spartacus/core'
import { MbBillingInformation } from '../../../models'

export const MB_CHECKOUT_BILLING_FORM_NORMALIZER = new InjectionToken<Converter<any, MbBillingInformation>>('MbCheckoutBillingFormNormalizer')
